import { useState, useEffect, useRef } from 'react';
import { Col, Row } from 'antd';
import LoanRateTitle from './LoanRateTitle.js';
import LoanRateCalculator from './LoanRateCalculator';
import LoanRateResult from './LoanRateResult';
import { PrequalHeader } from '../../Landing/LandingMenu.js'
import { useParams } from 'react-router-dom';

export default function LoanRate({ signUpOnly = false }) {

  const { customerid } = useParams();
  const [showResult, setShowResult] = useState(false);
  const [rehabBudget, setRehabBudget] = useState("")
  const [cashoutAmount, setCashoutAmount] = useState("")
  const [interestReserves, setInterestReserves] = useState("")
  const [landEntitlement, setLandEntitlement] = useState("")
  const [costToDate, setCostToDate] = useState("")
  const [monthFromPurchase, setMonthFromPurchase] = useState(0)
  const [onLanding, setOnLanding] = useState(true)

  useEffect(()=>{
    sessionStorage.setItem("cid", customerid)
  }, [])

  // Embedded on a customer's website by the one-line code (zeitrotag.js),
  // tell the parent page how tall the calculator is, so the iframe grows and
  // shrinks with the tabs, the result and the stacked phone layout instead of
  // cutting the page off.
  const containerRef = useRef(null)
  useEffect(() => {
    const el = containerRef.current
    if (!el || window.parent === window || typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(() => {
      const rect = el.getBoundingClientRect()
      window.parent.postMessage(
        { source: "tools", payload: [Math.ceil(rect.width), Math.ceil(rect.bottom + window.scrollY)] },
        "*"
      )
    })
    observer.observe(el)
    return () => observer.disconnect()
  }, [signUpOnly])

  if (signUpOnly) {
    return (
      <div className='h-100 d-flex flex-column'>
        <PrequalHeader app={true} setid={true} customerid={customerid}/>
        <LoanRateResult customerid={customerid} showResult={showResult} signUpOnly={signUpOnly}/>  
      </div>
    );
  }

  return (
    <div className='container' ref={containerRef} style={{maxWidth: '1274px', overflow: 'hidden'}}>
        <LoanRateTitle title='Hard Money Loan Rate Calculator' />
        <Row gutter={24}>
            <Col span={24} lg={14}>
                <LoanRateCalculator setShowResult={setShowResult} setRehabBudget={setRehabBudget} setCashoutAmount={setCashoutAmount} setInterestReserves={setInterestReserves} setLandEntitlement={setLandEntitlement} setOnLanding={setOnLanding} setCostToDate={setCostToDate} setMonthFromPurchase={setMonthFromPurchase} />
            </Col>
            <Col span={24} lg={10}>
                <LoanRateResult customerid={customerid} showResult={showResult} rehabBudget={rehabBudget} cashoutAmount={cashoutAmount} interestReserves={interestReserves} landEntitlement={landEntitlement} onLanding={onLanding} costToDate={costToDate} monthFromPurchase={monthFromPurchase} />  
            </Col>
        </Row>
    </div>
  );
}